function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getValueInRange } from './math';
export function getIndexesOfParticlesWithoutClonesInPage(_ref) {
  var pageIndex = _ref.pageIndex,
      particlesToShow = _ref.particlesToShow,
      particlesToScroll = _ref.particlesToScroll,
      particlesCount = _ref.particlesCount;
  var overlap = pageIndex === 0 ? 0 : particlesToShow - particlesToScroll;
  var from = pageIndex * particlesToShow - pageIndex * overlap;
  var to = from + Math.max(particlesToShow, particlesToScroll) - 1;
  var indexes = [];

  for (var i = from; i <= Math.min(particlesCount - 1, to); i++) {
    indexes.push(i);
  }

  return indexes;
}
export function getAdjacentIndexes(_ref2) {
  var infinite = _ref2.infinite,
      pageIndex = _ref2.pageIndex,
      pagesCount = _ref2.pagesCount,
      particlesCount = _ref2.particlesCount,
      particlesToShow = _ref2.particlesToShow,
      particlesToScroll = _ref2.particlesToScroll;

  var _pageIndex = getValueInRange(0, pageIndex, pagesCount - 1);

  var rangeStart = _pageIndex - 1;
  var rangeEnd = _pageIndex + 1;
  rangeStart = infinite ? rangeStart < 0 ? pagesCount - 1 : rangeStart : Math.max(0, rangeStart);
  rangeEnd = infinite ? rangeEnd > pagesCount - 1 ? 0 : rangeEnd : Math.min(pagesCount - 1, rangeEnd);

  var pageIndexes = _toConsumableArray(new Set([rangeStart, _pageIndex, rangeEnd, // because of these values outputs for infinite/non-infinites are the same
  0, // needed to clone first page particles
  pagesCount - 1 // needed to clone last page particles
  ])).sort(function (a, b) {
    return a - b;
  });

  var particleIndexes = pageIndexes.flatMap(function (pageIndex) {
    return getIndexesOfParticlesWithoutClonesInPage({
      pageIndex: pageIndex,
      particlesToShow: particlesToShow,
      particlesToScroll: particlesToScroll,
      particlesCount: particlesCount
    });
  });
  return {
    pageIndexes: pageIndexes,
    particleIndexes: _toConsumableArray(new Set(particleIndexes)).sort(function (a, b) {
      return a - b;
    })
  };
}